import { __decorate } from "tslib";
import { injectable } from "inversify";
let LocaleSource = class LocaleSource {
};
LocaleSource = __decorate([
    injectable()
], LocaleSource);
export { LocaleSource };
//# sourceMappingURL=LocaleSource.js.map